import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import { getDashboardPeriodInfo } from '../api/dashboardApi';
import { dashboardKeys } from './dashboardKeys';

export function useGetDashboardPeriodInfo() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: dashboardKeys.periodInfo(),
    queryFn: () => getDashboardPeriodInfo(),
    enabled: isAuthenticated,
    staleTime: 30_000,
  });
}
